import * as React from 'react';

import { translate } from '~l10n/client';
import { WorkspaceRole } from 'clients/app/src/api/workspaces/getWorkspaceMembers';

import { Dialog } from '~shared/components/Dialog';
import { Divider } from '~shared/components/Divider';
import { useWorkspacePermissionsV2 } from '~teacher/hook/workspaces';

import { InvitesDialogSection } from './InvitesDialogSection';

interface InvitesDialogProps {
  workspaceId: string;
  handleClose: () => void;
  isOpen: boolean;
}

export function InvitesDialog({
  workspaceId,
  handleClose,
  isOpen,
}: InvitesDialogProps) {
  const { permissions } = useWorkspacePermissionsV2({ workspaceId });

  return (
    <Dialog
      onClose={handleClose}
      padding={'default'}
      id="invite-workspace-dialog"
      open={isOpen}
      title={translate('Invite to Library')}
      closeLabel={translate('Cancel')}
    >
      <div className="text-base">
        <div className="flex flex-col align-top">
          <Divider />
          <div className="py-5 leading-8 text-base font-400 text-blue-600">
            <p>
              {translate('Share this to invite others to join your Library.')}
            </p>
          </div>
          {permissions.viewInviteViewerLink ? (
            <>
              <Divider />
              <InvitesDialogSection
                workspaceId={workspaceId}
                workspaceRole={WorkspaceRole.Viewer}
              />
            </>
          ) : null}
          {permissions.viewInviteEditorLink ? (
            <>
              <Divider />
              <InvitesDialogSection
                workspaceId={workspaceId}
                workspaceRole={WorkspaceRole.Editor}
              />
            </>
          ) : null}
        </div>
      </div>
    </Dialog>
  );
}
